// Lazy-initialize the login portal: the full provider tree and LogIn form
// are only loaded when Auth.required() or Auth.login() first opens the dialog.
// This avoids adding ~60 KiB to Guide/Answers pages for users who never log in.
let loginPortalPromise = null;

function loadLoginPortal() {
   if (!loginPortalPromise) {
      loginPortalPromise = import('Shared/LoginPortal')
         .then(m => m.initializeLoginPortal())
         .catch(error => {
            // Reset the cache so a later open() retries instead of being stuck
            // forever on a rejected promise (e.g. a transient chunk load
            // failure would otherwise permanently break the login modal).
            loginPortalPromise = null;
            throw error;
         });
   }
   return loginPortalPromise;
}

window.ReactLoginPortal = {
   open: options => {
      loadLoginPortal().then(
         () => window.ReactLoginPortal.open(options),
         error => console.error('Failed to load login portal', error)
      );
   },
   close: () => {
      if (loginPortalPromise) {
         loginPortalPromise.then(
            () => window.ReactLoginPortal.close(),
            () => {}
         );
      }
   },
};
